import styled from "@emotion/styled";
import { Box, Flex } from "@otrium/core";

const StyledCarouselHeader = styled(Flex)`
  place-items: center;
`;

export const ViewAllWrapper = styled(Box)`
  z-index: 2;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: none;
  }

  &.show-view-all-desktop {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    &.show-view-all-desktop {
      display: block;
    }
  }
`;

export { StyledCarouselHeader };
